module.exports = "<router-outlet></router-outlet>\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/theme/layouts/layout/layout.component.html
// module id = ./src/app/theme/layouts/layout/layout.component.html
// module chunks = main